<template>
  <div>
    <template v-if="editSoaIndex === index && disableDescription">
      <div class="bb-description-column-invoice">
              <ContactSoaInvoices :client="client"
                                  :soa="soa"
                                  :newSoa="newSoa"
                                  @createSoa="createSoa"
                                  :editSoaIndex="editSoaIndex"
                                  v-if="!soa.isAutoSoa"
                                  @changeBalance="changeBalance"
                                  @change="setInvoiceToSoa"/>
        <input class="bb-table-body__input bb-input bb-input_border"
               @keyup.enter="createSoa()"
               @input="setDescription"
               v-model="descriptionSoA"
               v-autofocus>
      </div>
    </template>
    <template v-else>
      <p v-html="setLinkToProforma(soa)"
         @click="openProforma($event, soa)"/>
    </template>
  </div>
</template>

<script>
import ContactSoaInvoices from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ContactSoaInvoices'
import _ from 'lodash'
export default {
  name: 'DescriptionColumn',
  props: ['client', 'editSoaIndex', 'newSoa', 'soa', 'index'],
  components: {ContactSoaInvoices},
  computed: {
    descriptionSoA: {
      get: function () {
        return _.get(this.soa, 'description', '')
      },
      set: function (data) {
        return _.set(this.soa, 'description', data)
      }
    },
    disableDescription () {
      return !this.soa.isAutoSoa && !this.soa.isCreditNote
    }
  },
  methods: {
    setInvoiceToSoa ({service, invoice, overPaid}) {
      this.$emit('change', {service: service, invoice: invoice, overPaid: overPaid})
    },
    changeBalance () {
      this.$emit('changeBalance')
    },
    setLinkToProforma (soa) {
      const regexp = /(Inv BB-.+-\d+-\d+)|(No BB-.+-\d+-\d+)/gim
      const regexpCredit = /No. CN\/\d+\/BB-\d+/gmi
      const regexpInvoice = /No. BB-.+-\d+-\d+/gmi
      let { description } = soa
      const invNumbers = description.match(regexp)
      const creditNumbers = description.match(regexpCredit)
      const invoiceNum = description.match(regexpInvoice)
      if (invNumbers) {
        const invNo = `<span id="invoice-number-one" class="bb-soa-body__invoice-number">${invNumbers[0]}</span>`
        description = description.replace(regexp, invNo)
      }
      if (creditNumbers) {
        const invNo = `<span id="credit-note" class="bb-soa-body__credit-note-number">${creditNumbers[0]}</span>`
        description = description.replace(regexpCredit, invNo)
      }
      if (invoiceNum) {
        const invNo = `<span id="invoice-number-two" class="bb-soa-body__invoice-number">${invoiceNum[0]}</span>`
        description = description.replace(regexpInvoice, invNo)
      }
      return description
    },
    openProforma (event, soa) {
      this.$emit('openProforma', event, soa)
    },
    createSoa () {
      this.$emit('createSoa')
    },
    setDescription () {
      this.$emit('setDescription', this.descriptionSoA)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
  .bb-description-column-invoice {
    @include global-font;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 10px;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/DescriptionColumn.vue